/**
 * NotFoundPage.jsx
 * 404 fallback page for QuitPact.
 * Displayed whenever the user navigates to an unrecognised route.
 *
 * Team: TA37 - The Coders' Assembly
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import CTAButton from '../components/common/CTAButton';
import './NotFoundPage.css';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <main className="not-found-page" aria-label="Page not found">
      <div className="not-found-page__container">

        <div className="not-found-page__icon" aria-hidden="true">🔍</div>

        <h1 className="not-found-page__heading">Page Not Found</h1>

        <p className="not-found-page__message">
          The page you are looking for does not exist or has been moved.
        </p>

        <CTAButton
          label="Back to Home"
          onClick={() => navigate('/')}
          ariaLabel="Return to the QuitPact homepage"
        />

      </div>
    </main>
  );
};

export default NotFoundPage;
